import PropTypes from 'prop-types'
import React from 'react'
import FormHelper from '../../businessLogic/formHelper'
import ReactMarkdown from 'react-markdown'
import FieldWrapper from './FieldWrapper'

class Static extends React.Component {
  render () {
    const { field, wrapperProps } = this.props

    return (
      <FieldWrapper
        label={FormHelper.decodeHTML(field.FieldName)}
        required={field.RequiredField}
        showDivider
        {...wrapperProps}
      >
        <div style={{ whiteSpace: 'normal' }} className='input-style'>
          <ReactMarkdown source={field.MetaData} escapeHtml linkTarget='_blank' />
        </div>
      </FieldWrapper>
    )
  }
}

Static.propTypes = {
  field: PropTypes.object.isRequired,
  wrapperProps: PropTypes.object
}

export default Static
